export const AppMenu = {
  ADMIN: 'admin',
  ANALYZE: 'analyze',
  CONNECT: 'connect',
  DATA: 'data',
  HOME: 'home',
  MANAGE: 'manage',
  RAVEN: 'zest',
  REPORT: 'ripley',
  SHARE: 'share',
  TAP_ORDERS: 'tap_orders',
  TRANSFORM: 'transform',
  SHEETS: 'sheets',
  FAVORITES: 'favorites',
};

export const NavGroup = {
  DATA_SOURCES: 'datasources',
  DRILLDOWNS: 'drilldowns',
  DASHBOARDS: 'all_dashboards',
  DATA_GROUPING: 'datagrouping',
  ORGANIZATION: 'organization',
  ACCOUNTS: 'accounts',
  AUTOMAPPING: 'automapping',
  REPORT_ENHANCEMENTS: 'report_enhancements',
  ONBOARDING: 'onboarding',
};

export const UPDATE_NAV_ITEM = 'update_nav_item';
export const CHANGE_ROUTE_TO_DASHBOARD = 'change_route_to_dashboard';

export const UN_IMPERSONATE_USER = 'un_impersonate_user';

export const AI_ASSISTANT_CLICK_EVENT = 'ai_assistant_click_event';
export const AI_ASSISTANT_PANEL_CLOSE_EVENT = 'ai_assistant_panel_close_event';
export const AI_CONFIGS_READY_EVENT = 'ai_configs_ready_event';
export const AI_ASSISTANT_RESULT_EVENT = 'ai_assistant_result_event';

export const AI_AGENT_COMPONENTS = {
  DASHBOARD: 'dashboard',
  REPORTSTUDIO: 'reportstudio',
  CALCULATION: 'calculation',
  WIDGET: 'widget',
  ADFLO_CONFIGURATION: 'adfloconfiguration',
  SCHEDULEDREPORT: 'scheduledreport',
};

export const ON_NAV_TOGGLE = 'on_nav_toggle';

export const WEBSITE_ANALYZER_AI_AGENT_COMPONENTS = {
  CLIENT: 'client',
  WEBSITEURL_PLACEHOLDER: 'https://example.com',
  SEO_AGENT: 'Website Analyzer',
};

export const URL_INPUT_AGENT_NAMES = [WEBSITE_ANALYZER_AI_AGENT_COMPONENTS.SEO_AGENT];
